import React from 'react';
import Button, { ButtonProps } from 'components/button';
import { useFormikContext } from 'formik';
import { usePrevious } from 'hooks';
import { throttle } from 'lodash';

function SubmitButton(props: ButtonProps) {
  const { isSubmitting } = useFormikContext();
  const previousIsSubmitting = usePrevious(isSubmitting);
  const [wasClicked, setWasClicked] = React.useState(false);

  React.useEffect(() => {
    if (previousIsSubmitting && isSubmitting === false && wasClicked) {
      setWasClicked(false);
    }
  }, [previousIsSubmitting, isSubmitting, wasClicked]);

  async function onClickHandler() {
    setWasClicked(true);
    if (props.onClick) {
      props.onClick();
    }
  }

  const onClick = React.useCallback(throttle(onClickHandler, 2000), []);

  return (
    <Button
      {...props}
      loading={isSubmitting}
      disabled={props.disabled || isSubmitting}
      onClick={onClick}
      type="submit"
    />
  );
}

export default SubmitButton;
